// Sessions API utility functions

import { API_BASE_URL, getAuthHeaders } from './apiConfig';

const SESSIONS_API = `${API_BASE_URL}/sessions`;

// Fetch all sessions
export async function fetchSessions() {
  const response = await fetch(SESSIONS_API, { headers: { ...getAuthHeaders() } });
  return response.json();
}

// Get session by ID
export async function fetchSession(sessionId) {
  const response = await fetch(`${SESSIONS_API}/${sessionId}`, { headers: { ...getAuthHeaders() } });
  return response.json();
}

export async function fetchSessionDocuments(sessionId) {
  const response = await fetch(`${SESSIONS_API}/${sessionId}/documents`, {
    headers: { ...getAuthHeaders() }
  });
  return response.json();
}

export async function uploadSessionDocument(sessionId, documentType, file) {
  const formData = new FormData();
  formData.append('documentType', documentType);
  formData.append('file', file);

  const response = await fetch(`${SESSIONS_API}/${sessionId}/documents`, {
    method: 'POST',
    headers: { ...getAuthHeaders() },
    body: formData
  });
  return response.json();
}

export async function updateSessionDocument(sessionId, documentId, file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${SESSIONS_API}/${sessionId}/documents/${documentId}`, {
    method: 'PUT',
    headers: { ...getAuthHeaders() },
    body: formData
  });
  return response.json();
}

export async function deleteSessionDocument(sessionId, documentId) {
  const response = await fetch(`${SESSIONS_API}/${sessionId}/documents/${documentId}`, {
    method: 'DELETE',
    headers: { ...getAuthHeaders() }
  });
  return response.json();
}